import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject 
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
//Model
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet, KeHoachHangVe, FileDinhKem, DSFileImport, FileImport } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';

@Component({
	selector: 'm-xac-nhan-kiem-tra-dialog',
	templateUrl: './xac-nhan-kiem-tra-dialog.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class XacNhanKiemTraComponent implements OnInit{

    /* Mat select search cho hàng hóa */
	listBoPhanKiemTra : any[] = [];
	selectBoPhanKiemTra : string = '';
	filteredBoPhanKiemTra: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	BoPhanKiemTraFilterCtrl: string = '';
	haveElementBoPhanKiemTra: boolean = false;
	/* ------------------------------------------------------------------ */
    
    /* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
	isSendPBKT: boolean = false;		// Gửi bộ phận mua hàng xác nhận?
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	selectQuyetDinh: string = '0';		// Chọn quyết định lô hàng
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	XacNhanForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	PassNhapForm: FormGroup;			//Form thông tin pass nhập
	TraHangForm: FormGroup;				//Form thông tin trả hàng
	hasTraHangFormErrors: boolean = false;
    /* ------------------------------------------------------------------ */

    /* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	thongTinHangVeItem: DeNghiNhapKhoChiTiet;
    
    constructor(
		public dialogRef: MatDialogRef<XacNhanKiemTraComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private XacNhanFB: FormBuilder,
		private PassNhapFB: FormBuilder,
		private TraHangFB: FormBuilder,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
    ) {
		this.dialogRef.disableClose = true;
	 }
    
    /** LOAD DATA */
	ngOnInit() {
		/*Get data from list when open dialog */
		this.thongTinHangVeItem = this.data.data;
	
		/*Load all dropdown and create form */
		this.ListBoPhanKiemTra();
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			if (event.altKey && event.keyCode == 83) {
				this.onSubmit();
			}
		});
	}
	
	/*Create Form with appropriate sub forms */
	createForm(){
		
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.thongTinHangVeItem.Nguoikiemtra = +idUser;

		/*Group các Form */
		this.XacNhanForm = this.XacNhanFB.group({
			BoPhanKiemTra : [!(this.thongTinHangVeItem.PbkiemTraId == undefined || this.thongTinHangVeItem.PbkiemTraId == 0) ? ('' + this.thongTinHangVeItem.PbkiemTraId) : '', Validators.required],
			NguoiKiemTra : [tenNguoiLap],
			NgayKiemTra: [new Date(), Validators.required],
			KetQua : [this.selectQuyetDinh, Validators.required]
		});
		this.XacNhanForm.controls["NguoiKiemTra"].disable();

		this.PassNhapForm = this.PassNhapFB.group({
			PassNhap: ['0',Validators.required]
		});

		this.TraHangForm = this.TraHangFB.group({
			TraHang: ['0',Validators.required],
			GhiChu: ['', Validators.required]
		});

	}
    
    /*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `Nhập kết quả kiểm tra hàng về`;
    }
    
    /*Lưu*/
	onSubmit() {
		
		this.hasFormErrors = false;
		const controls = this.XacNhanForm.controls;

		if (this.XacNhanForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}

		if(controls["KetQua"].value == 2){
			this.hasTraHangFormErrors = false;
			const controlsTH = this.TraHangForm.controls;
	
			if (this.TraHangForm.invalid) {
				Object.keys(controlsTH).forEach(controlName =>
					controlsTH[controlName].markAsTouched()
				);
				this.hasTraHangFormErrors = true;
				return;
			}
		}

		this.thongTinHangVeItem.PbkiemTraId = +controls["BoPhanKiemTra"].value;
		this.thongTinHangVeItem.TenNguoiKiemTra = controls["NguoiKiemTra"].value;
		this.thongTinHangVeItem.Ngaykiemtra = moment(new Date(controls["NgayKiemTra"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		this.thongTinHangVeItem.Quyetdinhlohang = +controls["KetQua"].value;
		if(controls["KetQua"].value == 2){
			this.thongTinHangVeItem.GhiChuKetQuaKiemTra = this.TraHangForm.controls["GhiChu"].value;
		}

		this.thongTinHangVeService.XacNhanKiemTra(this.thongTinHangVeItem).subscribe(res => {
			if (res.status == 1) {
				const message = `Xác nhận kiểm tra thành công`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Update, 3000, true, false);

				this.isChange = true;
				this.back();
			}
			else {
				this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Update, 30000, true, false);
			}
		});
    }
    
    /*Hàm lấy danh sách phòng ban*/
	ListBoPhanKiemTra(){
		this.thongTinHangVeService.listBoPhanKiemTra().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBoPhanKiemTra = res.data;
				this.filteredBoPhanKiemTra.next(this.listBoPhanKiemTra.slice());
				this.changeDetect.detectChanges();
			};
		});
	}
	filterBoPhanKiemTra() {
		if (!this.listBoPhanKiemTra) {
			return;
		}
		// get the search keyword
		let search = this.BoPhanKiemTraFilterCtrl;
		if (!search) {
			this.filteredBoPhanKiemTra.next(this.listBoPhanKiemTra.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredBoPhanKiemTra.next(
			this.listBoPhanKiemTra.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	/*------------------------------------------ */
    
    /*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(){
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				data: this.thongTinHangVeItem
			}
		);
	}
	/*------------------------------------------------------------- */

	/*Báo lỗi form invalid*/
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
	onAlertTraHangFormClose($event) {
		this.hasTraHangFormErrors = false;
	}
	/*------------------------------------------------------------- */
}